// extracted by mini-css-extract-plugin
export var shippingOptionImage = "_tm-0";